
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M3.327 2a.666.666 0 00-.664-.667A.665.665 0 002 2v12c0 .368.297.667.663.667A.666.666 0 003.327 14V9.333h7.466c.566 0 1.105-.242 1.483-.666L13.493 7.3a2.008 2.008 0 00.099-2.547l-.988-1.3a1.987 1.987 0 00-1.582-.786H3.327V2zm9.177 4.41a.668.668 0 00.033-.848l-.987-1.3A.663.663 0 0011.022 4H3.327v4h7.466a.66.66 0 00.494-.222l1.217-1.367z","clip-rule":"evenodd"}})])
          )
        }
      }
    